export const IntercomSourceType = {
    BANNER: 'banner',
    WIDGET: 'widget',
    CONTACT_US_ADMIN: 'contact_us_admin',
    DEEP_LINK: 'deep_link',
};
//# sourceMappingURL=intercom.config.js.map